import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, TrendingUp, ArrowRight } from 'lucide-react';

const WelcomePopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has seen the popup before
    const hasSeenPopup = localStorage.getItem('fcbb_popup_seen');
    
    if (!hasSeenPopup) {
      // Show popup after a short delay for better UX
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1500);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem('fcbb_popup_seen', 'true');
    setIsVisible(false);
  };

  const handleYes = () => {
    localStorage.setItem('fcbb_popup_seen', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={handleClose}
      />
      
      {/* Popup */}
      <div className="relative bg-card border border-border rounded-3xl shadow-2xl max-w-md w-full p-8 animate-in fade-in zoom-in duration-300">
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 p-2 rounded-full bg-secondary hover:bg-accent transition-smooth"
        >
          <X className="h-5 w-5 text-muted-foreground" />
        </button>

        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center">
            <TrendingUp className="h-10 w-10 text-primary" />
          </div>
        </div>

        {/* Content */}
        <h2 className="font-display text-2xl text-foreground text-center mb-3">
          Do You Know What Your Business Is Worth?
        </h2>
        <p className="text-muted-foreground text-center mb-8">
          Understanding your business value is the first step to a successful exit. Get our free guide to learn the key factors that determine your worth.
        </p>

        {/* Buttons */}
        <div className="flex flex-col gap-3">
          <Link
            to="/quick-read/quick-business-worth"
            onClick={handleYes}
            className="btn-primary w-full py-4 rounded-xl text-base font-semibold inline-flex items-center justify-center gap-2"
          >
            Yes, Show Me
            <ArrowRight className="h-5 w-5" />
          </Link>
          <button
            onClick={handleClose}
            className="w-full py-3 rounded-xl text-sm font-medium text-muted-foreground hover:text-foreground transition-smooth"
          >
            No thanks, maybe later
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomePopup;
